// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cls-1[data-v-15b2052d] {\n  fill: transparent;\n  stroke: currentColor;\n  stroke-linejoin: round;\n  stroke-width: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
